




























































import { Component, Vue, Prop, Emit, Watch } from "vue-property-decorator";
import { BlackListDto } from "@/store/blacklists/blacklist.interface";
import dayjs from "dayjs";
import ConfirmModal from "@/components/modal/Confirm.vue";

@Component
export default class AppBlackListForm extends Vue {
  @Prop() data: BlackListDto;
  @Prop({ default: false }) loading: boolean;
  @Prop({ default: false }) disabled: boolean;

  form: any = {};

  @Emit("onSubmit")
  async onSubmit() {
    return {
      ...this.form
    };
  }

  @Emit("onCancel")
  async onCancel() {}

  @Emit("onEditable")
  async onEditable() {}

  reset() {
    this.form = {
      name: ""
    };
  }

  @Watch("data", { immediate: true, deep: true })
  onDataChange(data: BlackListDto, oldData: BlackListDto) {
    const today = dayjs().format("YYYY-MM-DD");
    this.form = data
      ? {
          ...data
        }
      : {};
  }

  async onRemove() {
    return (this.$refs.confirmModal as ConfirmModal).open();
  }

  @Emit("onRemove")
  async onConfirmRemove() {
    return true;
  }
}
